import { RestClient } from '@/api/rest-client'
import { RealworksStatusRule } from '@/api/model/realworks-status-rule'
import { cloneDeep } from 'lodash'
import { Company } from '@/api/model/company'
import { Pipeline } from '@/api/model/pipeline'
import { PipelinePhase } from '@/api/model/pipeline-phase'
import { StatusReason } from '@/api/model/status-reason'

export class RealworksStatusRuleClient extends RestClient<RealworksStatusRule> {
    collectionName = 'realworks_status_rules'
    parseData = RealworksStatusRule.fromData

    async create(data: RealworksStatusRule): Promise<RealworksStatusRule> {
        const request = cloneDeep<any>(data)

        if (data.company instanceof Company) {
            request.company = data.company.resourceIdentifier
        }

        if (data.pipeline instanceof Pipeline) {
            request.pipeline = data.pipeline.resourceIdentifier
        }

        request.phases = data.phases.map((phase: PipelinePhase) => phase.resourceIdentifier)

        if (data.toNewStatusReason instanceof StatusReason) {
            request.toNewStatusReason = data.toNewStatusReason.resourceIdentifier
        }

        if (data.toPhase instanceof PipelinePhase) {
            request.toPhase = data.toPhase.resourceIdentifier
        }

        if (data.comment === null) {
            request.comment = ''
        }

        return super.create(request)
    }

    async update(id: string, data: RealworksStatusRule): Promise<RealworksStatusRule> {
        const request = cloneDeep<any>(data)

        if (data.company instanceof Company) {
            request.company = data.company.resourceIdentifier
        }

        if (data.pipeline instanceof Pipeline) {
            request.pipeline = data.pipeline.resourceIdentifier
        }

        request.phases = data.phases.map((phase: PipelinePhase) => phase.resourceIdentifier)

        if (data.toNewStatusReason instanceof StatusReason) {
            request.toNewStatusReason = data.toNewStatusReason.resourceIdentifier
        }

        if (data.toPhase instanceof PipelinePhase) {
            request.toPhase = data.toPhase.resourceIdentifier
        }

        if (data.comment === null) {
            request.comment = ''
        }

        return super.update(id, request)
    }
}
